<template>
    <div>
        <div class="mb-3 row">
            <div class="col-sm-12" v-if="Records.length <= 0">
                <b-button class="btn btn-outline-primary p-l-15 d-flex align-items-center" variant="outline-primary"
                    @click="checkLaunchLimit" v-bind:t_label="'EMPBE_ProductInfoCenter_Product_btnAddNew'">
                    <feather type="plus-circle"> </feather>
                    {{ $t("lbl_EMPBE_NotHaveProduct") }}
                </b-button>
            </div>
        </div>
        <b-overlay :show="loading" rounded="sm" v-if="Records.length > 0">
            <localization :language="kendoLang">
                <intl :locale="kendoLang">
                    <Grid ref="grid" :data-items="gridData" :resizable="true" :reorderable="true" :sortable="true"
                        :pageable="gridPageable" :groupable="false" :group="group" :sort="sort" :filter="filter"
                        :take="take" :skip="skip" :columns="columns" :column-menu="columnMenu" :selectable="true"
                        :filterable="true" :selected-field="selectedField" @headerselectionchange="onHeaderSelectionChange"
                        @filterchange="filterChange" @datastatechange="dataStateChange" @selectionchange="onSelectionChange"
                        :filter-cell-render="filterRender">
                        <toolbar>
                            <span class="k-textbox k-grid-search k-display-flex" v-if="false">
                                <b-form-input type="text" :placeholder="$t('lbl_SearchByKeyword')" v-model="searchWord"
                                    @input="onFilter"></b-form-input>
                            </span>
                            <span class="export-buttons">
                                <kbutton :theme-color="'secondary'" @click="checkLaunchLimit"
                                    v-bind:t_label="'EMPBE_ProductInfoCenter_Product_btnAddNew'">
                                    <i class="fa fa-plus-circle" style="line-height: 1.5;"></i>
                                    {{ $t("lbl_EMPBE_NewProduct") }}
                                </kbutton>
                                &nbsp;
                                <kbutton :theme-color="'primary'" @click="openOrderingPage" v-if="false"
                                    v-bind:t_label="'EMPBE_ProductInfoCenter_Product_btnOpenOrdering'">
                                    <i class="fa fa-list-ol" style="line-height: 1.5;"></i>
                                    {{ $t("lbl_EMPBE_ChangeOrder") }}
                                </kbutton>
                                &nbsp;
                                <kbutton :theme-color="'secondary'" @click="openMembershipInfoPage"
                                    v-bind:t_label="'EMPBE_ProductInfoCenter_Product_btnAddToCart'"
                                    :disabled="otherInfo ? otherInfo.product_TotalQty >= 50 : false">
                                    <i class="icon-shopping-cart" style="line-height: 1.5;"></i>
                                    {{ $t("lbl_EMPBE_AddActivateProduct") }}
                                    ({{ $t("lbl_EMPBE_Current") }}:{{ otherInfo ? otherInfo.product_LaunchedCount : 0
                                    }}/{{ otherInfo ? otherInfo.product_TotalQty : 0 }})
                                </kbutton>
                                <kbutton class="ml-2" v-if="false" :theme-color="'secondary'" 
                                :disabled="otherInfo.product_LaunchedCount == 0"
                                v-bind:t_label="'EMPBE_ProductInfoCenter_ExportProductList'"
                                @click="GenerateQRCode()"
                                >
                                <i class="fa fa-archive"></i>
                                    {{ $t('lbl_EMPBE_GenerateQRCode') }}
                                </kbutton>
                            </span>
                        </toolbar>
                        <template v-slot:productIdTemplate="{ props }">
                            <td v-if="props.rowType !== 'groupHeader'">
                                <router-link class="pl-0 no-router-link-exact-active fontcolor"
                                    :to="'/productInfoCenter/productDetail/' + props.dataItem.productId"
                                    v-b-toggle="'productRightpopup'"
                                    v-bind:t_label="'EMPBE_ProductInfoCenter_Product_' + props.dataItem.productId">
                                    {{ props.dataItem.name }}
                                </router-link>
                            </td>
                        </template>
                        <template v-slot:isFireTemplate="{ props }">
                            <!-- <td v-if="props.rowType !== 'groupHeader'">
                                <span class="badge badge-light-info m-r-5 m-l-5 f-16" v-if="props.dataItem.isFire" :onclick="handleclick(props.dataItem.id)">
                                    <i class="icofont icofont-fire-alt f-16 mr-0"></i>
                                    {{ $t('lbl_EMPBE_MainProd') }}
                                </span>
                                <span v-else class="badge-light badge m-r-5 m-l-5 f-16" :onclick="handleclick(props.dataItem.id)">
                                    {{ $t('lbl_EMPBE_NotMainProd') }}
                                </span>
                            </td> -->
                            <td v-if="props.rowType !== 'groupHeader'" :onclick="handleclick(props.dataItem.productId)">

                                <span class="badge badge-light-info m-r-5 m-l-5 f-16 fontcolor"
                                    v-if="props.dataItem.isFire">
                                    <div :id="`popover-bottom_${props.dataItem.productId}`" style=" cursor:pointer"
                                        tabindex="0" @click="onOpen(props.dataItem.productId)">
                                        <i class="icofont icofont-fire-alt f-16 mr-0"></i>
                                        {{ $t('lbl_EMPBE_MainProd') }}
                                    </div>
                                </span>
                                <span v-else class="badge-light badge m-r-5 m-l-5 f-16 fontcolor">
                                    <div :id="`popover-bottom_${props.dataItem.productId}`" style=" cursor:pointer"
                                        tabindex="0" @click="onOpen(props.dataItem.productId)">
                                        {{ $t('lbl_EMPBE_NotMainProd') }}
                                    </div>
                                </span>

                                <!-- placement="left"  triggers="focus"-->
                                <b-popover :ref="`ref_popover_${props.dataItem.productId}`"
                                    :target="`popover-bottom_${props.dataItem.productId}`">
                                    <template #title>
                                        {{ $t('lbl_EMPBE_ModifyFeaturedProd') }}
                                    </template>
                                    <b-form-select v-model="selectedMainProd">
                                        <option value="0">{{ $t('lbl_EMPBE_NotMainProd') }}</option>
                                        <option value="1">{{ $t('lbl_EMPBE_MainProd') }}</option>
                                    </b-form-select>
                                    <div style="padding: 10px;">
                                        <b-button variant="outline-primary" style="left: 5px;"
                                            @click="onClose(props.dataItem.productId)">{{ $t('lbl_cancel') }}</b-button>
                                        &nbsp; &nbsp;
                                        <b-button variant="primary" style="right: 5px;"
                                            @click="onSave(props.dataItem.productId)">{{ $t('lbl_EMPBE_Save') }}</b-button>
                                    </div>
                                </b-popover>
                            </td>
                        </template>
                        <template v-slot:featuredfilterSlotTemplate="{ props, methods }">
                            <div>
                                <DropDownList :data-items="featuredProdData" :text-field="'text'" :data-item-key="'value'"
                                    v-model="featureProdDefault" @change="(ev) => {
                                        if (ev.value.value >= 0) {
                                            props.onChange({
                                                operator: 'eq',
                                                field: props.field,
                                                value: ev.value.value > 0,
                                                syntheticEvent: ev,
                                            });
                                        } else {
                                            props.onChange({ operator: '', field: '', value: '', event: ev });
                                        }
                                        gridData = getData(items)
                                    }
                                        " />
                            </div>
                        </template>
                        <template v-slot:lastSubmitDateTemplate="{ props }">
                            <td v-if="props.rowType !== 'groupHeader'">
                                <!-- <custom-date :date="props.dataItem.lastSubmitDate"></custom-date> -->
                                {{ props.dataItem.lastSubmitDate }}
                            </td>
                        </template>
                        <template v-slot:lastSaveDateTemplate="{ props }">
                            <td v-if="props.rowType !== 'groupHeader'">
                                <custom-date :date="props.dataItem.lastSaveDate"></custom-date>
                                <span class="badge badge-warning m-r-5 m-l-5 f-16" v-if="false">
                                    <span
                                        v-if="(props.dataItem.lastSaveDate > props.dataItem.lastSubmitDate || props.dataItem.lastSubmitDate == undefined)">
                                        {{ $t('lbl_EMPBE_UnsubmittedDraft') }}</span>
                                    <!-- <span v-if="(props.dataItem.lastSaveDate == props.dataItem.lastSubmitDate)">
                                        {{ $t('lbl_EMPBE_Submitted') }}</span> -->
                                </span>
                            </td>
                        </template>
                        <template v-slot:statusDateTemplate="{ props }">
                            <td v-if="props.rowType !== 'groupHeader'">
                                <span v-if="props.dataItem.lastSubmitDate" class="badge-success badge m-r-5 m-l-5 f-16">{{
                                    $t('lbl_EMPBE_isActivate') }}</span>
                                <span v-else class="badge-info badge m-r-5 m-l-5 f-16">
                                    {{ $t('lbl_EMPBE_Draft') }}
                                </span>
                            </td>
                        </template>

                        <!-- <template v-slot:ActivateTemplate="{ props }">
                            <td v-if="props.rowType !== 'groupHeader'">
                                <span v-if="props.dataItem.IsLaunch" class="badge-light-success badge m-r-5 m-l-5 f-16">{{
                                    $t('lbl_EMPBE_isActivate') }}</span>
                                <span v-else class="badge-light badge m-r-5 m-l-5 f-16">
                                    {{ $t('lbl_EMPBE_NotActivate') }}
                                </span>
                            </td>
                        </template> -->
                        <template v-slot:filterSlotTemplate="{ props, methods }">
                            <div>
                                <k-input :placeholder="$t('lbl_EMPBE_SearchByKeyword')" :value="props.value" @input="(ev) => {
                                    props.onChange({
                                        operator: 'contains',
                                        field: props.field,
                                        value: ev.target.value,
                                        syntheticEvent: ev,
                                    });
                                    gridData = getData(items)
                                }
                                    " />
                            </div>
                        </template>
                        <template v-slot:DatefilterSlotTemplate="{ props, methods }">
                            <div>
                                <DropDownList :data-items="dateSortingData" :text-field="'text'" :data-item-key="'value'"
                                    :default-item="dateSortingDefault" @change="(ev) => {
                                        if (sort.filter(x => x.field == props.field).length > 0) {
                                            if (ev.value.value == '') {
                                                sort = sort.filter(x => x.field != props.field)
                                            } else {
                                                sort.find(x => x.field == props.field).dir = ev.value.value
                                            }
                                        } else if (ev.value.value != '') {
                                            sort.push({ dir: ev.value.value, field: props.field })
                                        }
                                        gridData = getData(items)
                                    }
                                        " />
                                <!-- <DateRangePicker @change="onDateRangePickerChange($event, props)"
                                    :start-date-input="'CustomStartDateInput'" :end-date-input="'CustomEndDateInput'"
                                    :start-date-input-settings="{ format: 'yyyy-MM-dd' }"
                                    :end-date-input-settings="{ format: 'yyyy-MM-dd' }">
                                    <template v-slot:CustomStartDateInput="{ props }">
                                        <CustomStartDateInput v-bind="props" />
                                    </template>
                                    <template v-slot:CustomEndDateInput="{ props }">
                                        <CustomEndDateInput v-bind="props" />
                                    </template>
                                </DateRangePicker> -->
                            </div>
                        </template>
                        <template v-slot:DateStatusfilterSlotTemplate="{ props, methods }">
                            <div class="row">
                                <div class="col-6 pr-0">
                                    <DropDownList :data-items="dateSortingData" :text-field="'text'"
                                        :data-item-key="'value'" :default-item="dateSortingDefault" @change="(ev) => {
                                            if (sort.filter(x => x.field == props.field).length > 0) {
                                                if (ev.value.value == '') {
                                                    sort = sort.filter(x => x.field != props.field)
                                                } else {
                                                    sort.find(x => x.field == props.field).dir = ev.value.value
                                                }
                                            } else if (ev.value.value != '') {
                                                sort.push({ dir: ev.value.value, field: props.field })
                                            }
                                            gridData = getData(items)
                                        }
                                            " />
                                </div>
                                <div class="col-6 pl-0">
                                    <DropDownList :data-items="statusSortingData" :text-field="'text'"
                                        :data-item-key="'value'" :default-item="statusSortingDefault" @change="(ev) => {
                                            if (ev.value.value == '') {
                                                props.onChange({ operator: '', field: '', value: '', event: ev });
                                            } else if (ev.value.value > 1) {
                                                props.onChange({
                                                    operator: 'isnotnull',
                                                    field: props.field,
                                                    value: 1,
                                                    syntheticEvent: ev,
                                                });
                                            } else {
                                                props.onChange({
                                                    operator: 'isnull',
                                                    field: props.field,
                                                    value: 1,
                                                    syntheticEvent: ev,
                                                });
                                            }
                                            gridData = getData(items)
                                        }
                                            " />
                                </div>
                            </div>
                        </template>
                        <template v-slot:StatusfilterSlotTemplate="{ props, methods }">
                            <DropDownList :data-items="statusSortingData" :text-field="'text'" :data-item-key="'value'"
                                :default-item="statusSortingDefault" @change="(ev) => {
                                    if (ev.value.value == '') {
                                        props.onChange({ operator: '', field: '', value: '', event: ev });
                                    } else if (ev.value.value > 1) {
                                        props.onChange({
                                            operator: 'isnotnull',
                                            field: props.field,
                                            value: 1,
                                            syntheticEvent: ev,
                                        });
                                    } else {
                                        props.onChange({
                                            operator: 'isnull',
                                            field: props.field,
                                            value: 1,
                                            syntheticEvent: ev,
                                        });
                                    }
                                    gridData = getData(items)
                                }
                                    " />
                        </template>
                    </Grid>
                </intl>
            </localization>
        </b-overlay>
        <visitorPermissionPopup PopupUid="PopupProduct"></visitorPermissionPopup>
    </div>
</template>

<script>
import { InquiryFormService } from '../../_services'
import visitorPermissionPopup from '@/components/visitorPermissionPopup'
import { Grid, GridToolbar } from '@progress/kendo-vue-grid';
import { Input } from '@progress/kendo-vue-inputs';
import { Button } from '@progress/kendo-vue-buttons';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import { process } from '@progress/kendo-data-query';
import { DateRangePicker } from '@progress/kendo-vue-dateinputs';
import { IntlProvider, load, LocalizationProvider, loadMessages } from '@progress/kendo-vue-intl';
import { productService } from '@/_services/product.service';
import CustomStartDateInput from '../../components/form/dateRangePicker/customStartDateInput.vue';
import CustomEndDateInput from '../../components/form/dateRangePicker/customEndDateInput.vue';

import { IsUAT } from '../../constants/config';

export default {
    inject: ['permissionData'],
    props: ["Records", "otherInfo", "addToCart"],
    components: {
        Grid: Grid,
        toolbar: GridToolbar,
        localization: LocalizationProvider,
        intl: IntlProvider,
        'k-input': Input,
        kbutton: Button,
        DropDownList,
        visitorPermissionPopup: visitorPermissionPopup,
        DateRangePicker,
        CustomStartDateInput,
        CustomEndDateInput
    },
    data() {
        return {
            IsUAT : IsUAT,
            loading: false,
            error: null,
            totalRows: 1,
            currentPage: 1,
            items: [],
            gridData: [],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            rowSelected: [],
            skip: 0,
            take: 10,
            group: [],
            sort: [],
            filter: {
                logic: 'and',
                filters: [],
            },
            gridPageable: {
                buttonCount: 5,
                info: true,
                type: 'numeric',
                pageSizes: true,
                previousNext: true,
            },
            searchWord: '',
            selectedField: 'selected',
            columnMenu: false,
            selectedMainProd: 1,
            featuredProdData: [
                { value: -1, text: this.$t('Lbl_PleaseSelect') },
                { value: 1, text: this.$t("lbl_EMPBE_MainProd") },
                { value: 0, text: this.$t("lbl_EMPBE_NotMainProd") }
            ],
            featureProdDefault: { value: -1, text: this.$t('Lbl_PleaseSelect') },
            dateSortingData: [
                { value: "asc", text: this.$t("lbl_EMP2_Sort_Asc") },
                { value: "desc", text: this.$t("lbl_EMP2_Sort_Dsc") }
            ],
            dateSortingDefault: { value: '', text: this.$t('Lbl_News_SortByDate') },
            statusSortingData: [
                { value: 1, text: this.$t("lbl_EMPBE_Draft") },
                { value: 2, text: this.$t("lbl_EMPBE_isActivate") }
            ],
            statusSortingDefault: { value: '', text: this.$t('lbl_EMPBE_FilterBy') },
        };
    },
    created() {
        this.gridData = this.getData(this.items);
    },
    computed: {
        langId() {
            return localStorage.getItem("currentLangId");
        },
        user() {
            return this.$store.state.authentication.user;
        },
        companyid() {
            return this.user.empCompanyId;
        },
        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return { text: f.label, value: f.key };
                });
        },
        selectedDataItems() {
            return this.gridData.data.filter((item) => item.selected === true);
        },
        areAllSelected() {
            return (
                this.selectedDataItems.length === this.gridData.data.length &&
                this.selectedDataItems.length !== 0
            );
        },
        columns() {
            return [
                { field: 'name', title: this.$t("Lbl_ProductName"), cell: 'productIdTemplate', filterCell: 'filterSlotTemplate' },
                { field: 'isFire', title: this.$t("lbl_EMPBE_MainProd") + ' (' + this.$t("lbl_EMPBE_PrioritizedForDisplay") + ')', cell: 'isFireTemplate', filter: 'boolean', filterCell: 'featuredfilterSlotTemplate', hidden: this.user.memberCode == 'FREE' },
                { field: 'lastSaveDate', title: this.$t("lbl_EMPBE_LastUpdateDate"), cell: 'lastSaveDateTemplate', filter: 'date', type: "date", format: '{0:yyyy-MM-dd HH:mm:ss}', filterCell: 'DatefilterSlotTemplate', },
                { field: 'lastSubmitDate', title: this.$t("lbl_EMPBE_LastSubmitDate"), cell: 'lastSubmitDateTemplate', filter: 'date', type: "date", format: '{0:yyyy-MM-dd HH:mm:ss}', filterCell: 'DatefilterSlotTemplate', },
                { field: 'lastSubmitDate', title: this.$t("lbl_buyerform_status"), cell: 'statusDateTemplate', filterCell: 'StatusfilterSlotTemplate', },

                // { field: 'IsLaunch', title: this.$t("lbl_EMPBE_isActivate"), cell: 'ActivateTemplate', filter: 'boolean' },
                // { field: 'uniqueCode', title: '操作', cell: 'ActionTemplate', filterable: false},
            ];
        },
        kendoLang() {
            switch (this.langId) {
                case "1252":
                    return "en-US";
                case "950":
                    return "zh-Hant";
                case "936":
                    return "zh-Hans";
                default:
                    return "zh-Hans";
            }
        },
    },
    mounted() {
        // Set the initial number of items
        this.totalRows = this.items.length;
        // this.items = this.Records;
        this.itemsRecordProcess();
        this.totalRows = this.Records.length;
        this.gridData = this.getData(this.items);
    },
    watch: {
        Records() {
            // this.items = this.Records;
            this.itemsRecordProcess();
            this.totalRows = this.Records.length;
            this.gridData = this.getData(this.items);
        }
    },

    methods: {
        itemsRecordProcess() {
            var r = this.Records;
            // r.forEach(item => {
            //     item.lastSaveDate = new Date(item.lastSaveDate);
            //     item.lastSubmitDate = new Date(item.lastSubmitDate)
            // })
            this.items = r;
        },
        handleclick(id) {
            // console.log("handleclick,id:" + id)

        },
        onSelectionChange(event) {
            event.dataItem[this.selectedField] = !event.dataItem[this.selectedField];
        },
        handleFilterChange: function (ev) {
            this.filter = ev.filter;

            this.gridData = this.getData(this.items);
        },
        filterChange: function (ev) {
            this.filter = ev.filter;
        },
        filterRender: function (h, defaultRendering, props, change) {
            return defaultRendering;
        },
        createAppState: function (dataState) {
            this.group = dataState.group;
            this.take = dataState.take;
            this.skip = dataState.skip;
            this.sort = dataState.sort;
            this.filter = dataState.filter;

            this.gridData = this.getData(this.items);
        },
        dataStateChange: function (event) {
            this.createAppState(event.data);
        },
        onFilter(e) {
            let inputValue = this.searchWord;
            this.skip = 0;
            if (inputValue !== '') {
                this.filter = {
                    logic: 'or',
                    filters: [
                        {
                            field: 'name',
                            operator: 'contains',
                            value: inputValue,
                        }
                    ],
                };
            } else this.filter = {
                logic: 'and',
                filters: [],
            };
            this.gridData = this.getData(this.items);
        },
        getData(data) {
            return process(data, {
                take: this.take,
                skip: this.skip,
                group: this.group,
                sort: this.sort,
                filter: this.filter,
            });
        },
        onHeaderSelectionChange(event) {
            let checked = event.event.target.checked;
            const tempData = this.items.map((item) => {
                return { ...item, selected: checked };
            });

            const tempGridData = this.gridData.data.map((item) => {
                return { ...item, selected: checked };
            });
            this.gridData.data = tempGridData;
            this.items = tempData;
        },
        openOrderingPage() {
            this.$root.$emit('bv::toggle::collapse', 'OrderRightpopup');
        },
        openMembershipInfoPage() {
            const localeStr = this.langId === "936" ? "simp" : this.langId === "950" ? "trad" : this.langId === "1252" ? "eng" : "simp";
            const newWindow = window.open(`https://www.chinaplasonline.com/eMarketplace/Supplier/${localeStr}`, '_blank');

            newWindow.addEventListener('DOMContentLoaded', function() {
                const targetElement = newWindow.document.querySelector('#supplier_MembershipsBenefits');
                let destY = targetElement.offsetTop;

                const stickyHeader = newWindow.document.querySelector('.sticky-header');
                destY -= stickyHeader.offsetHeight;

                newWindow.scrollTo({ top: destY, behavior: "smooth" });
            });
        },
        onOpen(id) {
            this.selectedMainProd = 0;
            this.items.forEach(element => {
                console.log(element)
                if (element.id == id) {
                    this.selectedMainProd = element.isFire ? 1 : 0;
                    this.$refs['ref_popover_' + id].$emit('open')
                } else {
                    this.onClose(element.id)
                }
            });
        },
        onClose(id) {
            this.$refs['ref_popover_' + id].$emit('close')
        },
        async onSave(id) {
            var that = this;
            //[19112024][SJP] Per isaac request, remove mainproduct count checking
            // if (this.selectedMainProd == 1) {
            //     var checkMainProdCount = await this.GetProductMainProdCount(id);
            //     if (!checkMainProdCount) {
            //         return;
            //     }
            // }
            var parms = { productid: id, isMainProduct: this.selectedMainProd };
            productService.UpdateProductMainProd(parms).then((res) => {
                if (res.isSuccessful) {
                    var message = that.$t('lbl_EMPBE_SaveSuccess');
                    that.alertMsg(message)
                    this.$emit('refreshGrid');
                } else {
                    var message = that.$t('lbl_EMPBE_Oprate_Filed');
                    that.alertMsg(message)
                }
                that.onClose(id)
            });
        },
        async GetProductMainProdCount(id) {
            var that = this;
            return productService.GetProductMainProdCount({ CompanyId: this.companyid, productId: id })
                .then((result) => {
                    if (result.isSuccessful && that.permissionData != null) {
                        if (result.data + 1 <= that.permissionData.MaxMainProdAmount) {
                            return true;
                        }
                    }
                    var message = that.$t('lbl_EMPBE_OverMainProdAmount');
                    that.alertMsg(message);
                    that.onClose(id)
                    return false;
                });
        },
        alertMsg(message) {
            this.$swal({
                text: message,
                showCancelButton: false,
            });
        },
        onDateRangePickerChange(e, props) {
            const currentFilters = this.filter.filters;

            const isDateRangeFilterApplied =
                currentFilters.filter((el) => el.customOperator == props.field).length !== 0;

            if (isDateRangeFilterApplied) {
                const index = currentFilters.map((e) => e.customOperator).indexOf(props.field);
                currentFilters.splice(index, 1);
            }

            var newFilters = [];
            if (e.value.start) {
                newFilters.push({
                    field: props.field,
                    operator: 'gte',
                    value: e.value.start,
                })
            }
            if (e.value.end) {
                newFilters.push({
                    field: props.field,
                    operator: 'lte',
                    value: e.value.end,
                })
            }

            this.filter.filters.push({
                customOperator: props.field,
                logic: 'and',
                filters: newFilters,
            });
            this.gridData = this.getData(this.items);
        },
        async checkLaunchLimit() {
            if ((this.otherInfo ? this.otherInfo.product_LaunchedCount : 0) + 1 > (this.otherInfo ? this.otherInfo.product_TotalQty : 0)) {
                var message = this.$t("lbl_EMPBE_OverActivateProdAmount");
                this.alertMsg(message);
            } else {
                this.$router.replace('/productInfoCenter/productDetail/0');
            }

            // let that = this;
            // var result = await productService
            //     .checkSysAccountPaymentInfo({
            //         CompanyId: this.companyid,
            //         type: "product",
            //         id: 0,
            //         demodate: "",
            //     })
            //     .then((res) => {
            //         if (res.isSuccessful) {
            //             if (res.data) {
            //                 let data = res.data;
            //                 if (data.launchCount + 1 > (this.otherInfo ? this.otherInfo.product_TotalQty : 0)) {
            //                     var message = that.$t("lbl_EMPBE_OverActivateProdAmount");
            //                     that.alertMsg(message);
            //                 } else {
            //                     this.$router.replace('/productInfoCenter/productDetail/0');
            //                 }
            //             } else {
            //                 var message = that.$t("lbl_EMPBE_OverActivateProdAmount");
            //                 that.alertMsg(message);
            //             }
            //         }
            //     });

        },
        async GenerateQRCode(){
            console.log('g')   
            return true
        }
    },
};
</script>
<style>
.fontcolor:hover {
    color: #a927f9;
}

.k-daterangepicker .k-floating-label-container {
    padding-left: 40px !important;
    padding-top: 0px !important;
}
</style>